// src/Modules/User/Presentation/reducers.ts
import { createSlice } from '@reduxjs/toolkit';
import { User } from '../Model/User';
import { loginThunk, initAuthThunk, refreshTokenThunk, refreshMeThunk, slotOpsOverrideThunk, clearSlotOpsOverrideThunk } from './actions';

const clearClientStorage = () => {
  try { localStorage.clear(); } catch { /* ignore */ }
  try { sessionStorage.clear(); } catch { /* ignore */ }
};

interface AuthState {
  user: User | null;
  access: string | null;
  refresh: string | null;
  loading: boolean;
}
const initialState: AuthState = { user: null, access: null, refresh: null, loading: false };

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.user = state.access = state.refresh = null;
      clearClientStorage();
    },
  },
  extraReducers: b => {
    /* login */
    b.addCase(loginThunk.pending, s => { s.loading = true; })
     .addCase(loginThunk.fulfilled, (s, a) => {
       s.loading  = false;
       s.user     = a.payload.user;
       s.access   = a.payload.tokens.access;
       s.refresh  = a.payload.tokens.refresh;
       localStorage.setItem('access',  s.access!);
       localStorage.setItem('refresh', s.refresh!);
     })
     .addCase(loginThunk.rejected, s => { s.loading = false; });

    /* init */
    b.addCase(initAuthThunk.fulfilled, (s, a) => {
      if (a.payload) {
        s.user    = a.payload.user;
        s.access  = a.payload.access;
        s.refresh = a.payload.refresh;
      }
    });

    /* refresh */
    b.addCase(refreshTokenThunk.fulfilled, (s, a) => {
      s.access = a.payload;
      localStorage.setItem('access', a.payload);
    });

    /* refresh me */
    b.addCase(refreshMeThunk.fulfilled, (s, a) => {
      s.user = a.payload;
    });

    /* slot ops override */
    b.addCase(slotOpsOverrideThunk.fulfilled, (s, a) => {
      s.user = a.payload;
    });

    b.addCase(clearSlotOpsOverrideThunk.fulfilled, (s, a) => {
      s.user = a.payload;
    });
  },
});

export const { logout } = slice.actions;
export default slice.reducer;
